import React from 'react'

const Beneftis = ({ height, width }) =>
    <svg version="1.1" id="benefitsIcon" xmlns="http://www.w3.org/2000/svg" width={ width } height={ height } x="0px" y="0px" viewBox="0 0 512 512" aria-labelledby="benefitsIconTitle" role="img">
      <title id="benefitsIconTitle">Beneftis Icon</title>
      <path className='blue-icon' d="M462,127H334.8V65c0-11-9-20-20-20H197.2c-11,0-20,9-20,20v62H50c-27.6,0-50,22.4-50,50v240
          c0,27.6,22.4,50,50,50h412c27.6,0,50-22.4,50-50V177C512,149.4,489.6,127,462,127z M217.2,85h77.5v42h-77.5L217.2,85L217.2,85z
          M50,167c2.2,0,406.4,0,412,0c5.5,0,10,4.5,10,10v100H314.8c-11,0-20,9-20,20v21h-77.5v-21c0-11-9-20-20-20H40V177
          C40,171.5,44.5,167,50,167z M462,427H50c-5.5,0-10-4.5-10-10V317h137.2v21c0,11,9,20,20,20h117.5c11,0,20-9,20-20v-21H472v100
          C472,422.5,467.5,427,462,427z"/>
    </svg>

export default Beneftis
